import React, { useState, useEffect } from "react";
import {
  Container,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import apiClient from "../../axiosInstance";
import showAlert from "../../components/Common/ShowAlert";
import TanstackTable from "../../components/Common/TanstackTable";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const PaymentMethods = () => {
  const [breadcrumbItems] = useState([
    { title: "Daryeel", link: "/" },
    { title: "Payment Methods", link: "#" },
  ]);

  const [data, setData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [methodName, setMethodName] = useState("");
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    const fetchMethods = async () => {
      try {
        const result = await apiClient.get("/payment/payment-methods");
        setData(result.data.response || result.data || []);
      } catch (err) {
        console.error("Error fetching payment methods:", err);
      }
    };
    fetchMethods();
  }, [modalOpen]);

  const toggleModal = () => {
    setEditId(null);
    setMethodName("");
    setModalOpen(!modalOpen);
  };

  const handleSave = async () => {
    try {
      let response;
      if (editId) {
        response = await apiClient.put(`/payment/payment-methods/${editId}`, {
          name: methodName,
        });
      } else {
        response = await apiClient.post("/payment/payment-methods", {
          name: methodName,
        });
      }
      await showAlert({
        title: editId ? "Update Payment Method" : "Create Payment Method",
        text: response.data.message,
        icon: response.data.status,
        goBack: false,
        timer: 5000,
      });
      if (response.data.status === "success") {
        setModalOpen(false);
        setMethodName("");
        setEditId(null);
      }
    } catch (err) {
      console.error("Error saving payment method:", err);
    }
  };

  const columns = [
    {
      id: "index",
      header: "No",
      cell: ({ row }) => row.index + 1,
    },
    {
      accessorKey: "name",
      header: "Payment Method",
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => (
        <span
          className={`badge bg-${
            row.original.status === "Active"
              ? "success"
              : row.original.status === "Inactive"
              ? "secondary"
              : "danger"
          }`}
        >
          {row.original.status}
        </span>
      ),
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => (
        <button
          className="btn btn-sm btn-primary"
          onClick={() => {
            setEditId(row.original.id);
            setMethodName(row.original.name);
            setModalOpen(true);
          }}
        >
          <i className="ri-file-edit-line"></i>
        </button>
      ),
    },
  ];

  return (
    <div className="page-content">
      <Container fluid>
        <div className="row">
          <div className="col-12">
            <Breadcrumbs
              title="Payment Methods"
              breadcrumbItems={breadcrumbItems}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Card>
              <CardBody>
                <div className="row">
                  <div className="col-12 text-end mb-2">
                    <button className="btn btn-primary" onClick={toggleModal}>
                      Create Payment Method
                    </button>
                  </div>
                </div>
                <TanstackTable data={data} columns={columns} />
              </CardBody>
            </Card>
          </div>
        </div>
        <Modal
          isOpen={modalOpen}
          toggle={toggleModal}
          centered={true}
          backdrop="static"
        >
          <ModalHeader toggle={toggleModal}>
            {editId ? "Update" : "Create"} Payment Method
          </ModalHeader>
          <ModalBody>
            <input
              type="text"
              className="form-control"
              placeholder="Payment Method Name"
              value={methodName}
              onChange={(e) => setMethodName(e.target.value)}
              required
            />
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-secondary" onClick={toggleModal}>
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleSave}
              disabled={!methodName.trim()}
            >
              Save
            </button>
          </ModalFooter>
        </Modal>
      </Container>
    </div>
  );
};

export default PaymentMethods;
